import type { IButtonBaseProps } from '@sixui/ui';
import { ButtonBase } from '@sixui/ui';
import { focusRingTokens } from '@sixui/ui/components/FocusRing/FocusRing.stylex';
import { shapeTokens } from '@sixui/ui/themes/base/shape.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';
import type { ITableBodyProps } from './TableBody';

export type IBodyActionProps = ITableBodyProps &
  IContainerProps &
  Pick<IButtonBaseProps, 'href' | 'onClick' | 'disabled'>;

const styles = stylex.create({
  host: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minHeight: '3.5rem',
    margin: '0.25rem',
    borderRadius: shapeTokens.corner$sm,
    padding: '0.75rem',
  },
});

const buttonFocusRingStyles = stylex.create({
  host: {
    [focusRingTokens.shape]: shapeTokens.corner$xs,
  },
});

export const TableBodyAction: React.FC<IBodyActionProps> = (props) => {
  const { sx, children, ...buttonProps } = props;

  return buttonProps.href || buttonProps.onClick ? (
    <ButtonBase
      sx={[styles.host, sx]}
      innerStyles={{ focusRing: buttonFocusRingStyles }}
      inwardFocusRing
      {...buttonProps}
    >
      {children}
    </ButtonBase>
  ) : (
    <div {...stylex.props(styles.host, sx)}>{children}</div>
  );
};
